import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LeftSidebarMenuComponent } from './left-sidebar-menu.component';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AdminSidebarMenuModule } from 'src/app/secure/admin/components/admin-sidebar-menu/admin-sidebar-menu.module';

@NgModule({
  declarations: [LeftSidebarMenuComponent],
  imports: [
    CommonModule,
    RouterModule,
    AccordionModule,
    ButtonModule,
    TooltipModule,
    MultiSelectModule,
    ReactiveFormsModule,
    FormsModule,
    AdminSidebarMenuModule,
  ],
  exports: [LeftSidebarMenuComponent],
})
export class LeftSidebarMenuModule {}
